/**
 * Shared helpers for turning an agents-list entry into the identifiers the
 * UserRelation endpoint needs.
 */
import profileService from '../api/services/profileService';
import type { AIBuddy } from '../types/user';

/**
 * The agents list carries the agent id; UserRelation needs the agent's user id.
 * They match today, but the buddy's profile is the authoritative source when
 * the id is not a usable number.
 */
export const resolveAgentUserId = async (buddy: AIBuddy): Promise<number | null> => {
  const fromId = Number(buddy.id);
  if (Number.isSafeInteger(fromId) && fromId > 0) return fromId;

  const guid = buddy.profileUserGuid || buddy.agentGuid;
  if (!guid) return null;

  const response = await profileService.getOtherUserProfile(guid);
  const userId = Number((response?.data as { userId?: number | string })?.userId);
  return Number.isSafeInteger(userId) && userId > 0 ? userId : null;
};
